module.exports = __webpack_public_path__ + "static/media/مناطق ريفية في أوروبا.7f0eceea.jpg";